/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genotype_genotype_scd_spline = exports.genotype_age_oth_spline = exports.genotype_syncope_scd_spline = exports.genotype_nsvt_scd_spline = exports.genotype_age_scd_spline = exports.genotype_grad_scd_spline = exports.genotype_la_scd_spline = exports.genotype_lvpwd_scd_spline = exports.genotype_ivsd_scd_spline = void 0;
function genotype_ivsd_scd_spline(x) {
    let value = -0.14132113 +
        0.0087066505 * x +
        0.00044088821 * Math.max(x - 2.1238109, 0) ** 3 -
        0.00075732106 * Math.max(x - 3.1601452, 0) ** 3 +
        0.0005652658 * Math.max(x - 4.1964794, 0) ** 3 -
        0.00039345793 * Math.max(x - 5.2328137, 0) ** 3 +
        0.00015962931 * Math.max(x - 6.269148, 0) ** 3 -
        8.7232854e-05 * Math.max(x - 7.3054823, 0) ** 3 +
        4.0917637e-05 * Math.max(x - 8.3418166, 0) ** 3 -
        5.8469264e-05 * Math.max(x - 9.3781509, 0) ** 3 +
        1.9703661e-05 * Math.max(x - 10.414485, 0) ** 3 -
        1.1432966e-05 * Math.max(x - 11.450819, 0) ** 3 +
        1.3778297e-05 * Math.max(x - 12.487154, 0) ** 3 +
        3.7429907e-06 * Math.max(x - 13.523488, 0) ** 3 -
        3.3833302e-06 * Math.max(x - 14.559822, 0) ** 3 +
        7.3319836e-06 * Math.max(x - 15.596157, 0) ** 3 +
        4.2127255e-05 * Math.max(x - 16.632491, 0) ** 3 +
        2.6822845e-06 * Math.max(x - 17.668825, 0) ** 3 -
        1.2731455e-05 * Math.max(x - 18.705159, 0) ** 3 +
        5.2518974e-05 * Math.max(x - 19.741494, 0) ** 3 +
        4.1194632e-05 * Math.max(x - 20.777828, 0) ** 3 -
        1.2685976e-05 * Math.max(x - 21.814162, 0) ** 3 +
        5.3250115e-06 * Math.max(x - 22.850497, 0) ** 3 +
        1.2603302e-06 * Math.max(x - 23.886831, 0) ** 3 -
        2.3434777e-06 * Math.max(x - 24.923165, 0) ** 3 +
        7.5936572e-06 * Math.max(x - 25.959499, 0) ** 3 -
        2.7460806e-05 * Math.max(x - 26.995834, 0) ** 3 -
        3.2446701e-05 * Math.max(x - 28.032168, 0) ** 3 +
        9.7431784e-06 * Math.max(x - 29.068502, 0) ** 3 -
        5.3938806e-06 * Math.max(x - 30.104837, 0) ** 3 +
        5.2968175e-06 * Math.max(x - 31.141171, 0) ** 3 -
        4.3183623e-06 * Math.max(x - 32.177505, 0) ** 3 +
        6.5800402e-06 * Math.max(x - 33.213839, 0) ** 3 -
        1.1277054e-05 * Math.max(x - 34.250174, 0) ** 3 +
        2.2610935e-05 * Math.max(x - 35.286508, 0) ** 3 -
        4.0508946e-05 * Math.max(x - 36.322842, 0) ** 3 +
        7.5482945e-05 * Math.max(x - 37.359177, 0) ** 3 -
        0.0001586563 * Math.max(x - 38.395511, 0) ** 3 +
        0.00021298915 * Math.max(x - 39.431845, 0) ** 3 -
        0.00029497387 * Math.max(x - 40.468179, 0) ** 3 +
        0.00017743113 * Math.max(x - 41.504514, 0) ** 3;
    return value;
}
exports.genotype_ivsd_scd_spline = genotype_ivsd_scd_spline;
function genotype_lvpwd_scd_spline(x) {
    let value = -0.040131474 +
        0.016039118 * x -
        9.3644754e-05 * Math.max(x + 2.0704811, 0) ** 3 +
        0.00016191524 * Math.max(x + 1.2953533, 0) ** 3 -
        0.00011869362 * Math.max(x + 0.52022546, 0) ** 3 +
        6.6496916e-05 * Math.max(x - 0.25490235, 0) ** 3 -
        4.1854559e-05 * Math.max(x - 1.0300302, 0) ** 3 +
        2.2033994e-05 * Math.max(x - 1.805158, 0) ** 3 -
        1.1770378e-05 * Math.max(x - 2.5802858, 0) ** 3 +
        6.3025649e-06 * Math.max(x - 3.3554136, 0) ** 3 -
        3.3830228e-06 * Math.max(x - 4.1305414, 0) ** 3 +
        1.8290629e-06 * Math.max(x - 4.9056692, 0) ** 3 -
        1.0131664e-06 * Math.max(x - 5.680797, 0) ** 3 +
        6.0627881e-07 * Math.max(x - 6.4559248, 0) ** 3 -
        4.4585132e-07 * Math.max(x - 7.2310527, 0) ** 3 +
        4.8060112e-07 * Math.max(x - 8.0061805, 0) ** 3 -
        8.5624607e-07 * Math.max(x - 8.7813083, 0) ** 3 +
        1.6066127e-05 * Math.max(x - 9.5564361, 0) ** 3 +
        8.5606508e-07 * Math.max(x - 10.331564, 0) ** 3 -
        3.4842877e-07 * Math.max(x - 11.106692, 0) ** 3 +
        1.7590603e-07 * Math.max(x - 11.88182, 0) ** 3 -
        9.3687124e-08 * Math.max(x - 12.656947, 0) ** 3 +
        5.1595794e-08 * Math.max(x - 13.432075, 0) ** 3 -
        3.0610203e-08 * Math.max(x - 14.207203, 0) ** 3 +
        2.2041717e-08 * Math.max(x - 14.982331, 0) ** 3 -
        2.2633124e-08 * Math.max(x - 15.757459, 0) ** 3 +
        3.4504242e-08 * Math.max(x - 16.532586, 0) ** 3 -
        7.8307837e-08 * Math.max(x - 17.307714, 0) ** 3 +
        3.5405312e-07 * Math.max(x - 18.082842, 0) ** 3 +
        3.0635571e-06 * Math.max(x - 18.85797, 0) ** 3 -
        1.6246596e-06 * Math.max(x - 19.633098, 0) ** 3 +
        2.4489895e-06 * Math.max(x - 20.408225, 0) ** 3 -
        4.3223325e-06 * Math.max(x - 21.183353, 0) ** 3 +
        7.9457871e-06 * Math.max(x - 21.958481, 0) ** 3 -
        1.4771909e-05 * Math.max(x - 22.733609, 0) ** 3 +
        2.752572e-05 * Math.max(x - 23.508737, 0) ** 3 -
        5.112165e-05 * Math.max(x - 24.283865, 0) ** 3 +
        9.3199287e-05 * Math.max(x - 25.058992, 0) ** 3 -
        0.00015600275 * Math.max(x - 25.83412, 0) ** 3 +
        0.00021144589 * Math.max(x - 26.609248, 0) ** 3 -
        0.00012277562 * Math.max(x - 27.384376, 0) ** 3;
    return value;
}
exports.genotype_lvpwd_scd_spline = genotype_lvpwd_scd_spline;
function genotype_la_scd_spline(x) {
    let value = -0.21117294 +
        0.044649443 * x +
        0.0089636577 * Math.max(x + 4.0063473, 0) ** 3 -
        0.016286903 * Math.max(x + 3.7812342, 0) ** 3 +
        0.012034376 * Math.max(x + 3.5561212, 0) ** 3 -
        0.0074221367 * Math.max(x + 3.3310082, 0) ** 3 +
        0.0039581375 * Math.max(x + 3.1058951, 0) ** 3 -
        0.0020913386 * Math.max(x + 2.8807821, 0) ** 3 +
        0.0010419055 * Math.max(x + 2.6556691, 0) ** 3 -
        0.00028746993 * Math.max(x + 2.430556, 0) ** 3 +
        0.00098487146 * Math.max(x + 2.205443, 0) ** 3 -
        0.00040675012 * Math.max(x + 1.98033, 0) ** 3 +
        0.00032202053 * Math.max(x + 1.7552169, 0) ** 3 -
        0.00042422617 * Math.max(x + 1.5301039, 0) ** 3 +
        0.0013596289 * Math.max(x + 1.3049909, 0) ** 3 +
        0.00084470454 * Math.max(x + 1.0798778, 0) ** 3 -
        0.00026980857 * Math.max(x + 0.8547648, 0) ** 3 +
        0.00012591521 * Math.max(x + 0.62965176, 0) ** 3 -
        5.5572862e-05 * Math.max(x + 0.40453873, 0) ** 3 -
        6.792335e-05 * Math.max(x + 0.1794257, 0) ** 3 -
        4.4767072e-05 * Math.max(x - 0.045687336, 0) ** 3 +
        2.6098166e-05 * Math.max(x - 0.27080037, 0) ** 3 -
        2.3064754e-05 * Math.max(x - 0.4959134, 0) ** 3 +
        2.522656e-05 * Math.max(x - 0.72102644, 0) ** 3 -
        0.00042860478 * Math.max(x - 0.94613947, 0) ** 3 +
        0.00016324052 * Math.max(x - 1.1712525, 0) ** 3 -
        0.00028226437 * Math.max(x - 1.3963655, 0) ** 3 +
        0.00056199893 * Math.max(x - 1.6214786, 0) ** 3 -
        0.0015731875 * Math.max(x - 1.8465916, 0) ** 3 -
        0.0041387553 * Math.max(x - 2.0717046, 0) ** 3 +
        0.00097699402 * Math.max(x - 2.2968177, 0) ** 3 -
        0.00066058551 * Math.max(x - 2.5219307, 0) ** 3 +
        0.00074814352 * Math.max(x - 2.7470437, 0) ** 3 -
        0.001524476 * Math.max(x - 2.9721568, 0) ** 3 +
        0.00035868274 * Math.max(x - 3.1972698, 0) ** 3 -
        0.0018094993 * Math.max(x - 3.4223828, 0) ** 3 +
        0.0036555805 * Math.max(x - 3.6474959, 0) ** 3 -
        0.0068722006 * Math.max(x - 3.8726089, 0) ** 3 +
        0.013305343 * Math.max(x - 4.0977219, 0) ** 3 -
        0.014025057 * Math.max(x - 4.322835, 0) ** 3 +
        0.0092380667 * Math.max(x - 4.547948, 0) ** 3;
    return value;
}
exports.genotype_la_scd_spline = genotype_la_scd_spline;
function genotype_grad_scd_spline(x) {
    let value = 0.025053719 -
        0.0023354457 * x +
        2.0468284e-06 * Math.max(x - 3.7485, 0) ** 3 -
        2.4279426e-06 * Math.max(x - 7.497, 0) ** 3 +
        2.9588899e-06 * Math.max(x - 11.2455, 0) ** 3 -
        1.3004378e-06 * Math.max(x - 14.994, 0) ** 3 +
        7.5728717e-08 * Math.max(x - 18.7425, 0) ** 3 -
        7.825573e-07 * Math.max(x - 22.491, 0) ** 3 +
        3.6990056e-07 * Math.max(x - 26.2395, 0) ** 3 -
        2.0470628e-06 * Math.max(x - 29.988, 0) ** 3 +
        1.5902967e-07 * Math.max(x - 33.7365, 0) ** 3 -
        2.3728219e-07 * Math.max(x - 37.485, 0) ** 3 -
        2.9754027e-07 * Math.max(x - 41.2335, 0) ** 3 -
        4.8342581e-09 * Math.max(x - 44.982, 0) ** 3 +
        2.709004e-07 * Math.max(x - 48.7305, 0) ** 3 +
        1.4984299e-07 * Math.max(x - 52.479, 0) ** 3 -
        3.4605612e-08 * Math.max(x - 56.2275, 0) ** 3 -
        5.9326429e-07 * Math.max(x - 59.976, 0) ** 3 +
        5.8101958e-08 * Math.max(x - 63.7245, 0) ** 3 -
        1.6934479e-07 * Math.max(x - 67.473, 0) ** 3 -
        6.2733673e-08 * Math.max(x - 71.2215, 0) ** 3 -
        2.8094305e-07 * Math.max(x - 74.97, 0) ** 3 +
        1.416057e-06 * Math.max(x - 78.7185, 0) ** 3 +
        7.5090155e-07 * Math.max(x - 82.467, 0) ** 3 -
        2.7024565e-07 * Math.max(x - 86.2155, 0) ** 3 +
        1.0344746e-06 * Math.max(x - 89.964, 0) ** 3 -
        6.6682066e-08 * Math.max(x - 93.7125, 0) ** 3 +
        6.31547e-08 * Math.max(x - 97.461, 0) ** 3 +
        1.1411714e-07 * Math.max(x - 101.2095, 0) ** 3 -
        7.9290254e-08 * Math.max(x - 104.958, 0) ** 3 +
        2.8971917e-07 * Math.max(x - 108.7065, 0) ** 3 +
        1.406945e-07 * Math.max(x - 112.455, 0) ** 3 -
        4.2615246e-08 * Math.max(x - 116.2035, 0) ** 3 -
        3.2277938e-07 * Math.max(x - 119.952, 0) ** 3 -
        2.3594516e-09 * Math.max(x - 123.7005, 0) ** 3 -
        7.6095773e-08 * Math.max(x - 127.449, 0) ** 3 -
        5.2856189e-07 * Math.max(x - 131.1975, 0) ** 3 +
        3.7930298e-07 * Math.max(x - 134.946, 0) ** 3 -
        7.0000865e-07 * Math.max(x - 138.6945, 0) ** 3 +
        4.2579889e-07 * Math.max(x - 142.443, 0) ** 3 -
        3.7625621e-07 * Math.max(x - 146.1915, 0) ** 3;
    return value;
}
exports.genotype_grad_scd_spline = genotype_grad_scd_spline;
function genotype_age_scd_spline(x) {
    let value = -0.23491254 -
        0.055171045 * x +
        0.0068457361 * Math.max(x - 0.45249005, 0) ** 3 -
        0.0090439349 * Math.max(x - 0.90224225, 0) ** 3 +
        0.0066650648 * Math.max(x - 1.3519944, 0) ** 3 -
        0.0047773367 * Math.max(x - 1.8017466, 0) ** 3 +
        0.0019813685 * Math.max(x - 2.2514988, 0) ** 3 -
        0.001765765 * Math.max(x - 2.701251, 0) ** 3 +
        0.00023083049 * Math.max(x - 3.1510032, 0) ** 3 -
        0.00077002367 * Math.max(x - 3.6007554, 0) ** 3 -
        0.00076519645 * Math.max(x - 4.0505076, 0) ** 3 -
        2.5618868e-05 * Math.max(x - 4.5002598, 0) ** 3 -
        0.00083359975 * Math.max(x - 4.950012, 0) ** 3 +
        0.00023877462 * Math.max(x - 5.3997642, 0) ** 3 +
        0.00066180862 * Math.max(x - 5.8495164, 0) ** 3 -
        7.2977217e-05 * Math.max(x - 6.2992686, 0) ** 3 +
        0.0013066694 * Math.max(x - 6.7490208, 0) ** 3 +
        9.4610639e-05 * Math.max(x - 7.198773, 0) ** 3 -
        0.00011307047 * Math.max(x - 7.6485252, 0) ** 3 +
        8.0121926e-05 * Math.max(x - 8.0982774, 0) ** 3 -
        0.00051270812 * Math.max(x - 8.5480296, 0) ** 3 -
        0.00066116463 * Math.max(x - 8.9977818, 0) ** 3 +
        0.0010630305 * Math.max(x - 9.447534, 0) ** 3 +
        0.00060971628 * Math.max(x - 9.8972862, 0) ** 3 +
        0.00039022778 * Math.max(x - 10.347038, 0) ** 3 +
        0.0015138923 * Math.max(x - 10.796791, 0) ** 3 -
        0.00060092256 * Math.max(x - 11.246543, 0) ** 3 -
        0.00085427114 * Math.max(x - 11.696295, 0) ** 3 +
        1.1317874e-05 * Math.max(x - 12.146047, 0) ** 3 -
        0.0012087247 * Math.max(x - 12.595799, 0) ** 3 +
        1.1336257e-06 * Math.max(x - 13.045552, 0) ** 3 +
        0.00063152174 * Math.max(x - 13.495304, 0) ** 3 +
        0.00014340749 * Math.max(x - 13.945056, 0) ** 3 +
        5.3100802e-05 * Math.max(x - 14.394808, 0) ** 3 +
        0.00055229587 * Math.max(x - 14.84456, 0) ** 3 -
        0.0017348524 * Math.max(x - 15.294313, 0) ** 3 -
        0.0013336704 * Math.max(x - 15.744065, 0) ** 3 +
        0.00067941492 * Math.max(x - 16.193817, 0) ** 3 -
        0.00013992824 * Math.max(x - 16.643569, 0) ** 3 +
        0.00038486785 * Math.max(x - 17.093321, 0) ** 3 +
        0.0010748531 * Math.max(x - 17.543074, 0) ** 3;
    return value;
}
exports.genotype_age_scd_spline = genotype_age_scd_spline;
function genotype_nsvt_scd_spline(x) {
    return 0.948489490309587 * x;
}
exports.genotype_nsvt_scd_spline = genotype_nsvt_scd_spline;
function genotype_syncope_scd_spline(x) {
    return 1.977733751914049 * x;
}
exports.genotype_syncope_scd_spline = genotype_syncope_scd_spline;
function genotype_age_oth_spline(x) {
    let value = 1.2556848 -
        0.41210237 * x +
        0.022546978 * Math.max(x - 0.45249005, 0) ** 3 -
        0.032253322 * Math.max(x - 0.90224225, 0) ** 3 +
        0.021971447 * Math.max(x - 1.3519944, 0) ** 3 -
        0.015173718 * Math.max(x - 1.8017466, 0) ** 3 +
        0.0064286581 * Math.max(x - 2.2514988, 0) ** 3 -
        0.0045769696 * Math.max(x - 2.701251, 0) ** 3 +
        0.0011369458 * Math.max(x - 3.1510032, 0) ** 3 -
        0.0011218285 * Math.max(x - 3.6007554, 0) ** 3 -
        0.000112082 * Math.max(x - 4.0505076, 0) ** 3 -
        0.0001928367 * Math.max(x - 4.5002598, 0) ** 3 -
        0.0003018066 * Math.max(x - 4.950012, 0) ** 3 +
        2.2567183e-05 * Math.max(x - 5.3997642, 0) ** 3 -
        0.00011730883 * Math.max(x - 5.8495164, 0) ** 3 +
        2.9251352e-06 * Math.max(x - 6.2992686, 0) ** 3 +
        6.8766369e-05 * Math.max(x - 6.7490208, 0) ** 3 -
        3.4577542e-05 * Math.max(x - 7.198773, 0) ** 3 +
        0.00018183354 * Math.max(x - 7.6485252, 0) ** 3 -
        3.2039428e-05 * Math.max(x - 8.0982774, 0) ** 3 +
        0.00024373467 * Math.max(x - 8.5480296, 0) ** 3 +
        5.8357117e-05 * Math.max(x - 8.9977818, 0) ** 3 +
        0.00017599358 * Math.max(x - 9.447534, 0) ** 3 +
        0.0001797059 * Math.max(x - 9.8972862, 0) ** 3 +
        6.2203499e-05 * Math.max(x - 10.347038, 0) ** 3 +
        0.0002630895 * Math.max(x - 10.796791, 0) ** 3 -
        2.596397e-05 * Math.max(x - 11.246543, 0) ** 3 +
        0.00025041989 * Math.max(x - 11.696295, 0) ** 3 -
        4.585296e-05 * Math.max(x - 12.146047, 0) ** 3 +
        0.00022911074 * Math.max(x - 12.595799, 0) ** 3 -
        3.1166354e-05 * Math.max(x - 13.045552, 0) ** 3 +
        0.00011698762 * Math.max(x - 13.495304, 0) ** 3 -
        1.3930075e-06 * Math.max(x - 13.945056, 0) ** 3 +
        4.9303845e-05 * Math.max(x - 14.394808, 0) ** 3 +
        2.4453737e-05 * Math.max(x - 14.84456, 0) ** 3 -
        1.8680796e-05 * Math.max(x - 15.294313, 0) ** 3 +
        8.7087121e-06 * Math.max(x - 15.744065, 0) ** 3 -
        1.7404542e-05 * Math.max(x - 16.193817, 0) ** 3 +
        2.7861472e-05 * Math.max(x - 16.643569, 0) ** 3 -
        3.0711824e-05 * Math.max(x - 17.093321, 0) ** 3 +
        3.7610188e-05 * Math.max(x - 17.543074, 0) ** 3;
    return value;
}
exports.genotype_age_oth_spline = genotype_age_oth_spline;
function genotype_genotype_scd_spline(x) {
    if (x) {
        return 0.28052145890574648;
    }
    else {
        return 0;
    }
}
exports.genotype_genotype_scd_spline = genotype_genotype_scd_spline;



// WEBPACK FOOTER //
// ./demo/pages/components/primacy-cal-js/genotype_spline_functions.js